<ng-template #selectRegions let-modal>
  <div class="sub-cate w-100">
    <div class="mb-2 w-100 d-flex justify-content-end">
      <input style="width: 150px" type="text" class="form-control" placeholder="Postal Code" maxlength="6" (keyup)="handlePostalCodeChange($event)" />
    </div>
    <div class="sub-cate__close" (click)="modal.dismiss('Cross click')">
      <i class="fa-solid fa-times"></i>
    </div>

    <ng-container>
      <!--THESE ARE THE MAIN REGIONS LISTS *ngIf was *ngIf="popupFilterOptionHeader == 'Category'"-->
      <div class="d-flex">
        <ng-container *ngFor="let r of regionCategoryImageList">
          <div class="card-region" [ngClass]="{ active: selectedRegionForCategoryPopup == r?.name }">
            <img loading="lazy" [src]="baseUrl + r.image" (click)="setCurrentRegion(r)" (error)="handleError($event)" />
            <div class="card-region__title">{{ r?.name | titlecase }}</div>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <hr />
    Sub Region ( Choose Up to 3 )<!--THESE ARE ARE SUBREGIONS   *ngIf="(popupFilterOptionHeader == 'Region' || (popupFilterOptionHeader == 'Category' 
      && selectedRegionForCategoryPopup)) && filterOptionPage == 'page1'">
        <h4 class="sub-cate__title" [ngClass]="{ 'text-center': popupFilterOptionHeader == 'Category' }" -->
    <section class="d-flex flex-wrap w-100" style="gap: 2em">
      <ng-container *ngFor="let i of currentFilteredSubregions">
        <div *ngIf="i.name?.toLowerCase() != 'all'">
          <input [id]="i?.name" type="checkbox" style="display: none" (change)="sunRegionButtonClicked($event, i)" [(ngModel)]="i.checked" />
          <label [for]="i?.name" [ngClass]="{ active: i.checked }" class="card-sub-cate">
            <div>
              <!-- <i class="icon" [class]="icons[i.categoryName]"></i> -->
              <div class="product-count">( {{ regionCounts[i?.subRegionId + "x" + subCategory?.id] || 0 }} )</div>
              <div class="card-sub-cate__title">
                {{ i?.name | titlecase }}
              </div>
            </div>
          </label>
        </div>
      </ng-container>
    </section>
    <hr />

    <!-- <div class="d-flex justify-content-end" style="gap: 1em;">
      <button (click)="fetchProductsBySubregions()" class="my-button-3">Filter <i class="fa fa-search" aria-hidden="true"></i></button>
     
    </div> -->
  </div>
</ng-template>
<!------------------------------------------------------------------------------------------------------------------------------------->
<ng-template #seeProductList let-modal>
  <p class="p-2 w-100" style="font-size: 1.4rem; font-weight: bold; text-align: center"><i class="fa-solid fa-handshake"></i> Similar Products</p>

  <div class="prods px-3">
    <ng-container *ngFor="let list of searchProds">
      <common-product-card-view [postalCode]="postalCode" (view)="goToProduct($event)" [list]="list" [isCommunityProduct]="true"> </common-product-card-view>
    </ng-container>
    <button class="addrecomm-btn" (click)="openRecommendationForm()">
      +
      <small>Recommend</small>
    </button>
  </div>
  <p *ngIf="searchProds.length < 1" class="p-3" style="text-align: center; color: var(--primary)"><i class="fas fa-heart-broken"></i> No products found for your search</p>
</ng-template>

<ng-template #suggestionsPopup let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Suggestions</h2>
    <div class="form-group">
      <textarea class="form-control" placeholder="Enter Your Suggestions" id="exampleFormControlTextarea1" maxlength="500" [(ngModel)]="memberMessage" rows="6"></textarea>
    </div>
    <button class="d-flex ml-auto my-button-3" (click)="submitSuggestion()">Submit <i class="fa fa-thumbs-up" aria-hidden="true"></i></button>
  </div>
</ng-template>

<ng-template #editCategory let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Edit Category</h2>
    <div class="form-group" *ngIf="isSubregionCombination">
      <label for="">Category Edit Mode</label>
      <select class="form-control" [(ngModel)]="categoryEditMode" (change)="categoryEditModeChange($event)">
        <option *ngFor="let sub of bottomSubregions" [value]="sub.slug">{{ sub.name }}</option>
      </select>
    </div>
    <!-- Event Image -->
    <!-- <h2>Event Image</h2> -->
    <img loading="lazy" *ngIf="imageBase64 && !isSubregionCombination" class="map-search-listing-img mt-2 product-char-image w-100" [src]="imageBase64" alt="" />
    <img loading="lazy" *ngIf="subCategory?.image && !isSubregionCombination" class="map-search-listing-img mt-2 product-char-image w-100" [src]="imgUrl + subCategory?.image" />

    <button class="com_btn px-1 month-list-add-more mt-0" (click)="upload.click()" *ngIf="!isSubregionCombination"><i class="fas fa-plus"></i> Upload Event Image</button>
    <input type="file" #upload (change)="saveProductCharSelectedImage($event)" class="suggestion-modal-pic-input d-none" accept="image/*" />
    <!-- End Event Image -->

    <!-- Banner Image -->
    <h6 class="mb-1">Banner Image</h6>
    <img loading="lazy" *ngIf="imageBase64Banner && !isSubregionCombination" class="map-search-listing-img mt-2 product-char-image w-100" [src]="imageBase64Banner" alt="" />
    <img loading="lazy" *ngIf="subCategory?.bannerImage && !isSubregionCombination" class="map-search-listing-img mt-2 product-char-image w-100" [src]="imgUrl + subCategory?.bannerImage" />

    <button class="com_btn px-1 month-list-add-more mt-0" (click)="uploadBanner.click()" *ngIf="!isSubregionCombination"><i class="fas fa-plus"></i> Upload Banner Image</button>
    <input type="file" #uploadBanner (change)="saveProductCharSelectedImage($event, true)" class="suggestion-modal-pic-input d-none" accept="image/*" />
    <!-- End Banner Image -->

    <!-- Promo Banner Image -->
    <h6 class="mb-1">Promo Banner Image</h6>
    <img loading="lazy" *ngIf="encodedPromoFile && !isSubregionCombination" class="map-search-listing-img mt-2 product-char-image w-100" [src]="encodedPromoFile" alt="" />
    <img loading="lazy" *ngIf="subCategory?.promoBannerImage && !isSubregionCombination" class="map-search-listing-img mt-2 product-char-image w-100" [src]="imgUrl + subCategory?.promoBannerImage" />

    <button class="com_btn px-1 month-list-add-more mt-0" (click)="uploadPromoImage.click()" *ngIf="!isSubregionCombination"><i class="fas fa-plus"></i> Upload Promo Image</button>
    <input type="file" #uploadPromoImage style="visibility: hidden" id="upload-promo-image" (change)="promoBannerChange($event)" class="suggestion-modal-pic-input d-none" accept="image/*" />

    <!-- End Promo Banner Image -->

    <div class="row" *ngIf="!isSubregionCombination">
      <div class="form-group col-12">
        <h6 class="mb-1">Redirect URL</h6>
        <input type="text" placeholder="Redirect URL" [(ngModel)]="promoRedirectURL" class="form-control" />
      </div>
    </div>

    <div class="row" *ngIf="isSubregionCombination">
      <div class="col-6">
        <button class="com_btn px-1 month-list-add-more mt-0 w-100" (click)="paginateRegion(false)"><i class="fas fa-chevron-left"></i> Previous Sub Region</button>
      </div>
      <div class="col-6">
        <button class="com_btn px-1 month-list-add-more mt-0 w-100" (click)="paginateRegion(true)">Next Sub Region <i class="fas fa-chevron-right"></i></button>
      </div>
    </div>

    <ul class="nav nav-tabs mt-3">
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{ active: formMenu == 'main' }" (click)="formMenu = 'main'">Main</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{ active: formMenu == 'meta' }" (click)="formMenu = 'meta'">Meta</a>
      </li>
      <li class="nav-item" *ngIf="!isSubregionCombination">
        <a class="nav-link" [ngClass]="{ active: formMenu == 'faq' }" (click)="formMenu = 'faq'">FAQ</a>
      </li>
    </ul>

    <ng-container *ngIf="formMenu == 'main'">
      <div class="row" *ngIf="!isSubregionCombination">
        <div class="form-group col-12">
          <h6 class="my-1">Category Name</h6>
          <input type="text" [(ngModel)]="categoryName" class="form-control" placeholder="Enter Category Name" />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <h6 class="mb-1">Bottom Text</h6>
          <textarea id="bottomText" [(ngModel)]="currentBottomText" rows="5" class="form-control" placeholder="Enter Bottom Text(HTML)"></textarea>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="formMenu == 'meta'">
      <div class="row">
        <div class="form-group col-12">
          <h6 class="mb-1">Meta Config</h6>
          <textarea readonly [(ngModel)]="domMeta" cols="30" rows="10" class="form-control" style="min-height: 300px" placeholder="Enter Meta Config"></textarea>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="formMenu == 'meta'">
      <div class="row">
        <div class="form-group col-12">
          <h6 class="mb-1">Schema Code</h6>
          <textarea readonly [(ngModel)]="domSchema" cols="30" rows="10" class="form-control" style="min-height: 300px" placeholder="Enter Schema Code"></textarea>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="formMenu == 'faq' && !isSubregionCombination">
      <!------------------------------------------------------------------------------------------>
      <div class="row">
        <div class="form-group col-12">
          <h6 class="mb-1">Question One</h6>
          <textarea [(ngModel)]="questionOne" placeholder="Question" cols="30" rows="1" class="form-control"></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <div>Answer One</div>
          <textarea [(ngModel)]="answerOne" placeholder="Answer One" cols="30" rows="5" class="form-control"></textarea>
        </div>
      </div>

      <!---------------------------------------------------------------------------------------------->

      <div class="row">
        <div class="form-group col-12">
          <h6 class="mb-1">Question Two</h6>
          <textarea [(ngModel)]="questionTwo" placeholder="Question" cols="30" rows="1" class="form-control"></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <div>Answer Two</div>
          <textarea [(ngModel)]="answerTwo" placeholder="Answer Two" cols="30" rows="5" class="form-control"></textarea>
        </div>
      </div>

      <!---------------------------------------------------------------------------------------------->

      <div class="row">
        <div class="form-group col-12">
          <h6 class="mb-1">Question Three</h6>
          <textarea [(ngModel)]="questionThree" placeholder="Question" cols="30" rows="1" class="form-control"></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <div>Answer Three</div>
          <textarea [(ngModel)]="anserThree" placeholder="Answer Three" cols="30" rows="5" class="form-control"></textarea>
        </div>
      </div>

      <!---------------------------------------------------------------------------------------------->

      <div class="row">
        <div class="form-group col-12">
          <h6 class="mb-1">Question Four</h6>
          <textarea [(ngModel)]="questionFour" placeholder="Question" cols="30" rows="1" class="form-control"></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <div>Answer Four</div>
          <textarea [(ngModel)]="anserFour" placeholder="Answer Four" cols="30" rows="5" class="form-control"></textarea>
        </div>
      </div>

      <!---------------------------------------------------------------------------------------------->

      <div class="row">
        <div class="form-group col-12">
          <h6 class="mb-1">Question Five</h6>
          <textarea [(ngModel)]="questionFive" placeholder="Question" cols="30" rows="1" class="form-control"></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <div>Answer Five</div>
          <textarea [(ngModel)]="anserFive" placeholder="Answer Five" cols="30" rows="5" class="form-control"></textarea>
        </div>
      </div>
    </ng-container>

    <duv class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" (click)="editCategorySubmit()">Save</button>
    </duv>
  </div>
</ng-template>

<!------------------------------------------------------------------------------------------------------>
<main class="search-page" role="main">
  <h1 class="d-none" *ngIf="!isLoading || currentPage > 0">
    <ng-container *ngIf="isSubregionCombination"> Best </ng-container>
    <ng-container *ngIf="isTypeInfoLoaded">
      {{ currentTypeName }}
    </ng-container>
    {{ currentCategoryName }}
    <ng-container *ngIf="isSubregionCombination">in {{ currentSubRegionName }}</ng-container>
  </h1>
  <div class="container" style="max-width: 1440px">
    <nav aria-label="Breadcrumb navigation">
      <div class="d-flex justify-content-between">
        <app-breadcrumb *ngIf="breadCrumbData" [data]="breadCrumbData"></app-breadcrumb>
        <div class="back-button-section hidden-desktop">
          <button class="back-button" (click)="goBack()" aria-label="Go back to previous page"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</button>
        </div>
      </div>
    </nav>

    <article class="rounded header-wrapper w-100 d-flex justify-content-start align-items-center flex-column" style="width: fit-content; position: relative">
      <ng-template #catTitle>
        <header class="d-flex flex-column" *ngIf="isOnBrowser">
          <nav class="d-flex flex-wrap w-100 mb-1" *ngIf="typeList?.length" aria-label="Product types">
            <button *ngFor="let type of typeList" class="btn btn-sm btn-outline-primary ml-2" (click)="searchSimilarSubType(type)" [attr.aria-label]="'Search for ' + type.name + ' products'">{{ type.name }}</button>
          </nav>
          <div class="header-input">
            <div class="title" *ngIf="!isLoading || currentPage > 0">
              <button class="back" (click)="goBack()" aria-label="Go back to previous page"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>
              <div>
                <ng-container *ngIf="isSubregionCombination"> Best </ng-container>
                <ng-container *ngIf="isTypeInfoLoaded">
                  {{ currentTypeName }}
                </ng-container>
                {{ currentCategoryName }}
                <ng-container *ngIf="isSubregionCombination">in {{ currentSubRegionName }}</ng-container>
              </div>
            </div>
            <button class="btn btn-sm btn-dark" (click)="openSelectRegions()" style="height: fit-content" aria-label="Search by region">Region Search</button>
          </div>
          <p *ngIf="isSubregionCombination && !(totalMemberShopProductList?.length == 0 && (!isLoading || currentPage > 0))" class="sub-title">Choose from {{ totalMemberShopProductList.length }} {{ currentCategoryName }} in {{ currentSubRegionName }}</p>
          <div class="d-flex align-items-center justify-content-between my-2">
            <div class="d-flex flex-wrap w-100 justify-content-between">
              <button *ngIf="isUserAnAdmin" class="btn btn-sm btn-outline-primary" [class.mb-3]="totalMemberShopProductList?.length == 0 && !isLoading && currentPage > 01" style="top: 0; left: 100%; width: 8rem" (click)="openEditCategoryModal()" aria-label="Edit category settings">
                <i class="fa fa-ellipsis-v mr-2" aria-hidden="true"></i>
                Edit Category
              </button>
              <!-- <button (click)="openReport()" class="btn btn-sm btn-outline-primary">
                🐞 Report Bug
              </button>
              <button (click)="openSuggestModal(suggestionsPopup, 'Recommendation')" class="btn btn-sm btn-outline-primary ml-2">
                💡 Suggest
              </button> -->
              <!-- <button class="btn btn-sm btn-dark" (click)="openSelectRegions()" style="height: fit-content;"
                aria-label="Search by region">Region Search</button> -->
              <ng-container *ngFor="let sub of currentFilteredSubregions">
                <button class="btn btn-sm btn-outline-primary active m-1" *ngIf="sub.checked" [attr.aria-label]="'Remove ' + sub?.name + ' from filter'">
                  {{ sub?.name }}
                  <i class="fa fa-x" (click)="sub.checked = false; fetchProductsBySubregions()" aria-hidden="true"></i>
                </button>
              </ng-container>
            </div>
            <!-- <div>
              <input style="width: 150px" type="text" class="form-control" placeholder="Postal Code" maxlength="6" (keyup)="handlePostalCodeChange($event)" />
            </div> -->
          </div>
          <!-- Sub category -->
          <app-my-carousel-swiper *ngIf="subCategory.relationCategories.length" class="my-carousel-width-auto hidden-desktop" [slide]="subCategory.relationCategories" [config]="carouselWithNavOptions2">
            <div class="swiper-slide" *ngFor="let sub of subCategory.relationCategories">
              <button class="my-cate-carousel" [class.inactive-cate]="sub.name != currentCategoryName" (click)="goToPage('/category/' + sub.slug)" [attr.aria-label]="'View ' + sub.name + ' category'">{{ sub.name }}</button>
            </div>
          </app-my-carousel-swiper>
          <nav class="grid-sub-cate mb-2 hidden-mobile" aria-label="Related categories">
            <!-- <button class="cate" style="background: var(--secondary); color: var(--white);">{{currentCategoryName}}</button> -->
            <button class="cate" [class.inactive-cate]="sub.name != currentCategoryName" (click)="goToPage('/category/' + sub.slug)" *ngFor="let sub of subCategory.relationCategories" [attr.aria-label]="'View ' + sub.name + ' category'">{{ sub.name }}</button>
          </nav>
          <app-my-carousel-swiper *ngIf="subCategoryList?.length" class="my-carousel-width-auto hidden-mobile" [slide]="subCategoryList" [config]="carouselWithNavOptions2">
            <div class="swiper-slide" *ngFor="let i of subCategoryList">
              <button class="my-cate-carousel" (click)="goToPage('/category/' + i.slug)" [attr.aria-label]="'View ' + i?.categoryName + ' subcategory'">
                {{ i?.categoryName }}
              </button>
            </div>
          </app-my-carousel-swiper>
          <nav class="grid-sub-cate hidden-mobile" *ngIf="subCategoryList?.length" aria-label="Subcategories">
            <button class="cate" (click)="goToPage('/category/' + i.slug)" *ngFor="let i of subCategoryList" [attr.aria-label]="'View ' + i?.categoryName + ' subcategory'">
              {{ i?.categoryName }}
            </button>
          </nav>
        </header>
      </ng-template>
      <router-outlet></router-outlet>

      <div class="hidden-mobile h-100 w-100">
        <div class="grid-wrapper">
          <aside>
            <div class="back-button-section w-100">
              <button class="back-button" (click)="goBack()" aria-label="Go back to previous page"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</button>
            </div>
            <app-product-types-list [showAllTypes]="true" [editable]="false" *ngIf="isInitDone" [showViaPopup]="false" (selectedType)="setCurrentType($event)" (typeList)="typeList = $event" [categoryId]="subCategory?.id" [class.d-none]="((!typesExist || !isInitDone) && !isUserAnAdmin) || isMainCategory" (typesExist)="typesExist = $event; realignSwiperIndexWhenTabsChange()"></app-product-types-list>
          </aside>

          <!-- Product List -->
          <section class="d-flex flex-column" style="background: #fff; padding: 1rem; border-radius: 0.5rem; box-shadow: 0 2px 4px #0000001a" aria-label="Product listings">
            <!---->
            <div style="max-height: 16rem; overflow: hidden">
              <img loading="lazy" (load)="topImageLoad($event)" *ngIf="currentCategoryBG" [src]="imgUrl + currentCategoryBG" [alt]="'Banner image for ' + currentCategoryName + ' category'" />
            </div>

            <div *ngTemplateOutlet="catTitle"></div>

            <div class="products mb-2 pt-0 w-100" role="list" [attr.aria-label]="'List of ' + currentCategoryName + ' products'">
              <common-product-card-view style="height: 100%" [postalCode]="postalCode" (view)="viewProductDetails($event)" [isSelected]="i < 5" [canBeSelected]="isSelectProductsToCompareOn" (selected)="productSelectedChanged(list, $event)" *ngFor="let list of totalMemberShopProductList; let i = index" [list]="list" [isCommunityProduct]="true" [toSinglePage]="true" role="listitem"></common-product-card-view>
              <button class="addrecomm-btn" (click)="openRecommendationForm()" aria-label="Recommend a product for this category">
                +
                <small>Recommend</small>
              </button>
            </div>
            <div class="show-more" (click)="getProductList()" role="button" tabindex="0" [attr.aria-label]="'Load more ' + currentCategoryName + ' products'" (keyup.enter)="getProductList()" (keyup.space)="getProductList()">
              <div *ngIf="currentPage < lastPage && !isLoading">Show more <i class="fa-solid fa-chevron-down" aria-hidden="true"></i></div>
              <div *ngIf="currentPage < lastPage && isLoading" aria-live="polite">Loading...</div>
            </div>
            <!-- <ng-container *ngIf="totalMemberShopProductList?.length == 0 && (!isLoading || currentPage > 0)">
              <div class="d-flex flex-column">
                <div *ngTemplateOutlet="catTitle"></div>
              </div>
            </ng-container> -->
          </section>

          <aside class="d-flex flex-column" style="gap: 1em" aria-label="Additional actions and information">
            <button class="btn m-1 mb-2 search-btn" *ngIf="productsToCompare?.length" (click)="isSelectProductsToCompareOn ? openCompareProductsModal() : turnComparisonOn()" [attr.aria-label]="isSelectProductsToCompareOn ? 'Compare selected products' : 'Select products to compare'">
              <i class="fa-solid fa-code-compare" aria-hidden="true"></i>
              {{ isSelectProductsToCompareOn ? " Compare Products" : " Select To Compare" }}
            </button>

            <button class="btn search-btn" (click)="isSelectProductsToCompareOn = false" *ngIf="isSelectProductsToCompareOn" aria-label="Cancel product comparison"><i class="fa fa-x" aria-hidden="true"></i> Cancel Comparison</button>
            <app-product-faq-list [categoryId]="subCategory?.id" (faqsExist)="faqsExist = $event"></app-product-faq-list>
          </aside>
        </div>
      </div>
      <div class="hidden-desktop h-100 w-100 custom-swiper-2">
        <app-my-carousel-swiper class="product-mobile-swiper custom-swiper-2" [config]="carOptions" cssClass="custom-swiper-2" [navigation]="false">
          <div class="swiper-slide">
            <ng-container>
              <div *ngTemplateOutlet="catTitle"></div>
            </ng-container>
            <app-product-types-list [showAllTypes]="true" [editable]="false" *ngIf="isInitDone" [showViaPopup]="false" (selectedType)="setCurrentType($event)" (typeList)="typeList = $event" [categoryId]="subCategory?.id" [class.d-none]="((!typesExist || !isInitDone) && !isUserAnAdmin) || isMainCategory" (typesExist)="typesExist = $event; realignSwiperIndexWhenTabsChange()" [viewDesignScroll]="true"></app-product-types-list>

            <ng-container *ngIf="totalMemberShopProductList?.length == 0">
              <div class="d-flex flex-column">
                <!-- <div *ngTemplateOutlet="catTitle" class="mb-2"></div> -->
                <div style="display: flex; justify-content: center; flex-direction: column; align-items: center; height: 200px; font-size: 1.5rem; border: dotted 3px #59288040" role="status" aria-live="polite">
                  <p><i class="fa fa-exclamation-circle" aria-hidden="true"></i> No Item found</p>
                </div>
              </div>
            </ng-container>

            <div class="d-flex flex-column justify-content-center mt-2">
              <div class="products mb-2 pt-0 w-100" role="list" [attr.aria-label]="'List of ' + currentCategoryName + ' products'">
                <common-product-card-view style="height: 100%" [postalCode]="postalCode" (view)="viewProductDetails($event)" [isSelected]="i < 5" [canBeSelected]="isSelectProductsToCompareOn" (selected)="productSelectedChanged(list, $event)" *ngFor="let list of totalMemberShopProductList; let i = index" [list]="list" [isCommunityProduct]="true" [toSinglePage]="true" role="listitem"></common-product-card-view>
                <button class="addrecomm-btn" (click)="openRecommendationForm()" aria-label="Recommend a product for this category">
                  +
                  <small>Recommend</small>
                </button>
              </div>
              <div class="show-more" (click)="getProductList()" role="button" tabindex="0" [attr.aria-label]="'Load more ' + currentCategoryName + ' products'" (keyup.enter)="getProductList()" (keyup.space)="getProductList()">
                <div *ngIf="currentPage < lastPage">Show more <i class="fa-solid fa-chevron-down" aria-hidden="true"></i></div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <aside class="d-flex flex-column" aria-label="Additional actions and information">
              <button class="btn m-1 mb-2 search-btn" *ngIf="productsToCompare?.length" (click)="isSelectProductsToCompareOn ? openCompareProductsModal() : turnComparisonOn()" [attr.aria-label]="isSelectProductsToCompareOn ? 'Compare selected products' : 'Select products to compare'">
                <i class="fa-solid fa-code-compare" aria-hidden="true"></i>
                {{ isSelectProductsToCompareOn ? " Compare Products" : " Select To Compare" }}
              </button>

              <button class="btn search-btn" (click)="isSelectProductsToCompareOn = false" *ngIf="isSelectProductsToCompareOn" aria-label="Cancel product comparison"><i class="fa fa-x" aria-hidden="true"></i> Cancel Comparison</button>
              <app-product-faq-list [categoryId]="subCategory?.id" (faqsExist)="faqsExist = $event"></app-product-faq-list>
            </aside>
          </div>
        </app-my-carousel-swiper>
      </div>
      <!-- <div>
        <button class="btn btn-secondary w-100 mb-2 d-block d-md-none mt-3" (click)="showMap = !showMap">
          <i [ngClass]="showMap ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
          {{ showMap ? "Hide Map" : "Show Map" }}
        </button>
      </div>
      <div class="mt-2 map container" [class.d-none]="totalMemberShopProductList?.length == 0 || !showMap" id="map">
      </div> -->

      <section *ngIf="bottomText && bottomText != 'undefined' && bottomText != 'null'" class="mt-2 bottom-text" [innerHTML]="bottomText" aria-label="Additional category information"></section>

      <footer class="d-flex justify-content-start bottom-btns">
        <div>
          <app-product-review [categoryName]="currentCategoryName" [subRegionName]="currentSubRegionName" (openProd)="viewProductDetails($event)" [categoryId]="currentCategoryId" [isParent]="!parentCategory?.id" [withCarousel]="false"></app-product-review>
          <section *ngIf="subCategory.relationCategories?.length > 0" aria-labelledby="other-categories-heading">
            <h2 id="other-categories-heading" class="header_title">Other Categories</h2>

            <nav class="list" aria-label="Related categories">
              <ng-container *ngFor="let sub of subCategory.relationCategories">
                <span class="mr-2 mt-2" *ngIf="sub.name != currentCategoryName">
                  <button class="my-button-3" [routerLink]="'/category/' + sub.slug" [attr.aria-label]="'View ' + sub.name + ' category'">
                    <h3>{{ sub.name }}</h3>
                  </button>
                </span>
              </ng-container>
            </nav>
          </section>

          <section aria-labelledby="nearby-locations-heading">
            <h2 id="nearby-locations-heading" class="header_title">Nearby {{ subCategory?.name }}</h2>

            <nav class="list" aria-label="Nearby locations">
              <ng-container *ngFor="let region of bottomSubregions">
                <span class="mr-3 mt-2" *ngIf="region?.name?.toLowerCase() != 'all'">
                  <a style="text-decoration: underline" (click)="setRegion(region)" role="button" tabindex="0" [attr.aria-label]="'View ' + subCategory?.name + ' in ' + region?.name" (keyup.enter)="setRegion(region)" (keyup.space)="setRegion(region)"> {{ subCategory?.name }} in {{ region?.name }} </a>
                </span>
              </ng-container>
            </nav>
          </section>
        </div>
      </footer>
    </article>
  </div>
  <app-marketplace #marketplace [share]="true"></app-marketplace>
</main>
